




















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormModal extends Vue {
  @Prop({ type: String })
  modalText!: string;

  @Prop({ type: String })
  btnText!: string;

  @Prop({ type: String })
  bottomText!: string;

  @Prop({ type: String })
  btnLink!: string;

  @Prop({ type: Boolean })
  changeStatusProp!: boolean;

  private cdId: null | number = null;

  private modalCountdown = (cb: () => void, time: number) => {
    return window.setTimeout(cb, time);
  };

  public CtestShow() {
    this.$modal.show("modal-open");
    this.cdId = this.modalCountdown(() => {
      this.toTop(this.btnLink);
    }, 5000);
    setInterval(() => {
      this.modalCount -= 1;
    }, 1000);
  }

  private toTop(btnLink: string) {
    if (this.changeStatusProp === false) {
      this.$router.push({ name: btnLink });
    } else {
      this.pChangeStatus();
    }
  }

  private modalCount = 5;

  private changeStatus = false;

  private created() {
    if (this.changeStatusProp === true) {
      this.changeStatus = this.changeStatusProp;
    }
  }

  private pChangeStatus() {
    this.$emit("changeStatus");
    this.changeStatus = false;
    if (this.cdId !== null) {
      window.clearTimeout(this.cdId);
    }
  }
}
